import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { formatCurrency } from '@/utils/money';
import { Text, View } from 'react-native';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

interface Props {
  amount: number;
  invoiceNumber: string;
}

export const OverduePaymentSupportInfo: React.FC<Props> = ({
  amount,
  invoiceNumber,
}) => {
  const [styles] = useStyles();
  const { currencyCode } = useVariantPackInfoContext();

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={[FONTS.primarySemiBold, styles.description]}>
          {formatCurrency(amount, currencyCode)}
        </Text>
        <Text style={[FONTS.primary, styles.description]}>{invoiceNumber}</Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    borderColor: theme.sk.color.border.primary,
    borderRadius: 8,
    borderWidth: 1,
    justifyContent: 'center',
    minHeight: 48,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  description: {
    color: theme.colors.primary,
    fontSize: 14,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
